import { render, staticRenderFns } from "./De.vue?vue&type=template&id=0c5831a8&scoped=true&"
var script = {}
import style0 from "./De.vue?vue&type=style&index=0&id=0c5831a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5831a8",
  null
  
)

export default component.exports